module.exports = __webpack_public_path__ + "img/spin_btn.1037ce10.png";